import React from "react";
import PropTypes from "prop-types";
import { Box, AppBar, Toolbar } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import * as workpalJS from "@workpal-build/workpaljs";

const styles = {
  link: {
    color: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontSize: "17px",
    fontWeight: 600,
  },
  backButton: {
    position: "absolute",
    left: "16px",
  },
};

function Headerbar({ title, closeOption, backLink, deepLinksrc }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (closeOption) {
      closeOption();
    } else {
      navigate(-1);
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" className="appHeader">
        <Toolbar sx={{ justifyContent: "center" }}>
          {deepLinksrc === "otherminiapp" ? (
            <CloseIcon
              sx={styles.backButton}
              onClick={() => {
                workpalJS.closeWebView();
              }}
            />
          ) : !!backLink ? (
            <Link style={styles.link} to={backLink}>
              <ArrowBack sx={styles.backButton} />
            </Link>
          ) : (
            <ArrowBack onClick={handleBack} sx={styles.backButton} />
          )}

          <div style={styles.title}>{title}</div>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

Headerbar.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Headerbar;
